<template>
  <div class="pt-6 pb-12 space-y-6">
    <div class="flex flex-col mx-6 space-y-3">
      <Button :link="tenant.company.order_landing_via_portal_url" text="Place Order" />

      <div class="text-center">
        <Typography variant="body">
          Credit Balance:
          <strong>{{
            formatCents(authCustomer.credit_balance_amount, tenant.company.currency)
          }}</strong>
        </Typography>
      </div>

      <div>
        <hr class="h-1 mt-3" />
      </div>
    </div>

    <div class="space-y-6">
      <SidebarSection
        v-for="section in useNavigation().sections.filter((section) => section.show)"
        :key="section.name"
        :name="section.name"
      >
        <SidebarItem
          v-for="item in section.children.filter((item) => item.show && item.targetRouteName)"
          :key="item.name"
          :name="item.name"
          :image="item.image"
          :icon-component="item.icon"
          :target-route-name="item.targetRouteName"
          :is-inertia-link="item.routeIsInertia"
          :route-names-to-check-if-current="item.routeNamesToCheckIfCurrent"
          :ghost="item.ghost || false"
          :badge="item.badge"
          item-of-primary-column
        />
      </SidebarSection>
    </div>

    <div class="flex-col space-y-6 md:hidden">
      <hr class="h-1 mx-6" />

      <SidebarSection name="Current Group" :use-negative-margin="false">
        <CustomerDropdown :dark-mode="false" />
      </SidebarSection>

      <hr class="h-1 mx-6" />

      <SidebarSection :use-negative-margin="false">
        <form method="post" :action="route('web.customer.login.destroy')" class="h-full">
          <CsrfToken />
          <button
            type="submit"
            class="flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-md hover:text-gray-900 hover:bg-gray-50 group"
          >
            <LogoutIcon
              class="w-5 h-5 mr-3 text-gray-500 shrink-0 group-hover:text-gray-600"
              aria-hidden="true"
            />
            Logout
          </button>
        </form>
      </SidebarSection>
    </div>
  </div>
</template>

<script setup>
import { LogoutIcon } from '@heroicons/vue/outline'
import { Typography, Button } from '@aryeo/runway'

import useNavigation from '@/Hooks/Customer/useNavigation'
import { useTenant } from '@/Hooks/Shared/useTenant'
import { useAuth } from '@/Hooks/Customer/useAuth'

import CustomerDropdown from '@/Components/Customer/Header/CustomerDropdown'
import CsrfToken from '@/Components/Shared/CsrfToken'
import SidebarItem from '@/Components/Customer/Sidebar/SidebarItem'
import SidebarSection from '@/Components/Shared/Navigation/Sidebar/SidebarSection'
import { formatCents } from '@/Utils/CurrencyFormatter'

const { tenant } = useTenant()
const { authCustomer } = useAuth()
</script>
